exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--Star__2l9qB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:13px;color:#c07e00;height:30px;line-height:20px}.styles--Star__2l9qB:after{display:inline-block;content:\" \";width:20px;height:18px;margin-left:3px;vertical-align:top;background:url(/public/images/_anti/student/sprite.png) no-repeat 0 0;background-size:500px 500px;background-position:-400px 0}\n", ""]);

// exports
exports.locals = {
	"Star": "styles--Star__2l9qB",
	"star": "styles--Star__2l9qB"
};